<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="9"
      r="8"
      fill="white"
      :stroke="color"
      stroke-width="1.5"
    />
    <path d="M8 8H10V14H8V8Z" :fill="color" />
    <rect x="8" y="4" width="2" height="2" :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: "#514F4F",
    },
  },
};
</script>
